<script lang="ts" setup>
  import type { PlayersGuessingView } from '../../../../shared/api/round.ts';
  import { Center } from '../../../../shared/ui/center';
  import { Logo } from '../../../../shared/ui/logo';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import SongCard from '../song/SongCard.vue';
  import RoundHeader from './RoundHeader.vue';

  defineProps<{ data: PlayersGuessingView; secondsLeft: string; isHost: boolean }>();
</script>

<template>
  <MobileViewLayout space="m">
    <template #header>
      <RoundHeader :is-host="isHost" :seconds-left="secondsLeft" :view="data" />
    </template>

    <Logo class="waiting-logo" />

    <Center as="p" class="waiting-text" measure="20rem">Waiting for people to guess your song</Center>

    <SongCard v-if="data.round.songSubmission" :song="data.round.songSubmission.song" label="you chose" />
  </MobileViewLayout>
</template>

<style scoped>
  .waiting-logo {
    --logo-size: 3rem;

    filter: drop-shadow(0 4px 6px var(--color-shadow));
  }

  .waiting-text {
    font-size: var(--font-size-lg);
    line-height: 1.2;
    margin: 0;
    text-align: center;
  }
</style>
